import { render, staticRenderFns } from "./HMEmpty.vue?vue&type=template&id=87063b28&scoped=true&"
import script from "./HMEmpty.vue?vue&type=script&lang=ts&"
export * from "./HMEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./HMEmpty.vue?vue&type=style&index=0&id=87063b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87063b28",
  null
  
)

export default component.exports